/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest =
  {
    ledgerCanisterId: string;
  };

/** @internal */
export const GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$inboundSchema:
  z.ZodType<
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$Outbound =
  {
    ledger_canister_id: string;
  };

/** @internal */
export const GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$outboundSchema:
  z.ZodType<
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$Outbound,
    z.ZodTypeDef,
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$ {
  /** @deprecated use `GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$inboundSchema;
  /** @deprecated use `GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$outboundSchema;
  /** @deprecated use `GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$Outbound` instead. */
  export type Outbound =
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$Outbound;
}

export function getTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequestToJSON(
  getTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest:
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest,
): string {
  return JSON.stringify(
    GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$outboundSchema
      .parse(
        getTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest,
      ),
  );
}

export function getTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest' from JSON`,
  );
}
